import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
// import { Router, ActivatedRoute, Params } from "@angular/router";
import {FlashMessagesService} from 'angular2-flash-messages';

import 'rxjs/add/operator/toPromise';

import {URL_API} from './../constante';
import {HEADERS} from './../constante';
import {Utils} from '../shared/utils';

import {Usuario} from '../usuario/usuario';

@Injectable()
export class CadastroService {

    private url_api = URL_API + '/usuario';


    // update(usuario: Usuario): Promise<Usuario>{
    //   let headers = new Headers({ 'Content-Type': 'application/json' });
    //   let options = new RequestOptions({ headers: headers });
    //   return this.http
    //              .put(this.url_api+"/"+usuario.id, JSON.stringify(usuario), options)
    //              .toPromise()
    //              .then(this.extractData)
    //              .catch(this.handleErrorPost);
    // }


    save(usuario: Usuario): Promise<Response> {
        return this.http
            .post(this.url_api, JSON.stringify(usuario), {headers: HEADERS})
            .toPromise()
            .then(response => this.utils.handle(response))
            .catch((error) => this.utils.handleError(error));
    }

    update(usuario: Usuario): Promise<Response> {
        return this.http
            .post(this.url_api+"/update", JSON.stringify(usuario), {headers: HEADERS})
            .toPromise()
            .then(response => this.utils.handle(response))
            .catch((error) => this.utils.handleError(error));
    }

    getUsuario(id: number): Promise<Usuario> {
        let url: string = this.url_api + '/' + id;
        return this.http.get(url)
            .toPromise()
            .then(response => response.json() as Usuario)
            .catch((error) => this.utils.handleError(error));
    }

    getUserbyMail(dados): Promise<Usuario> {

        let url = URL_API +'/usuario/email';
        return this.http
            .post(url, dados, {headers: HEADERS})
            .toPromise()
            .then(response => response.json()  as Usuario)
            .catch((error) => this.utils.handleError(error));
    }


    constructor(private http: Http,
                private flashMessagesService: FlashMessagesService, 
				private utils: Utils) {
    }
}



// WEBPACK FOOTER //
// ./src/app/cadastro/cadastro.service.ts